import React, { useState } from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { Box } from '@kufox/mui';

import { styled } from '@kufox/mui/emotion';

import { NAMESPACE, RISK_TAG } from '../constants';
import Tabs from '../../components/Tabs';
import GFA from './GFA';
import SMS from './SMS';
import { useLang } from '../../hookTool';
import { getTrackingSource } from '../../common/tools';

const Title = styled.h2`
  font-size: 34px;
  line-height: 48px;
  margin-top: 0;
  margin-bottom: 16px;
`;

const Subtitle = styled(Box)`
  font-size: 12px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.text60};
  margin-bottom: 40px;
`;

const SafeWordBox = styled(Box)`
  width: 100%;
  margin-top: 32px;
  background: ${({ theme }) => theme.colors.primary8};
  z-index: 0;
  padding: 32px 40px;
  .safeword {
    font-size: 16px;
    line-height: 24px;
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 500;
    margin: 0;
  }
  .safewordTips {
    font-size: 12px;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.text60};
    font-weight: 400;
    margin-top: 16px;
    margin-bottom: 0;
  }
`;

const RiskAlert = styled('Box')`
  border-radius: 4px;
  padding: 9px 16px;
  margin-bottom: 24px;
  color: ${(props) => props.theme.colors.text};
  background: ${(props) => props.theme.colors.complementary8};
  font-size: 14px;
  line-height: 22px;
`;

export default function ValidateForm(props) {
  const {
    onSuccess,
    verifyCanNotUseClick,
    showLoginSafeWord,
    classes = {},
    isSub = false,
    trackingConfig = {},
  } = props;
  const { needValidations, loginSafeWord, riskTag } = useSelector((state) => state[NAMESPACE]);
  const headValidation = _.head(needValidations);
  const defaultTabKey = _.head(headValidation);
  const { warnText } = RISK_TAG[riskTag] || {};

  const [tabKey, setTabKey] = useState(defaultTabKey);

  const { t } = useLang();

  const tracksourceParam = getTrackingSource(trackingConfig);
  const validations = {
    google_2fa: {
      title: t('gfa_google'),
      render(props = {}) {
        return <GFA {...props} trackResultParams={{ source: tracksourceParam }} />;
      },
    },
    my_sms: {
      title: t('gfa_sms'),
      render(props = {}) {
        return <SMS {...props} trackResultParams={{ source: tracksourceParam }} />;
      },
    },
  };

  return (
    <Box display="flex" flexDirection="column" height="100%">
      <Box flex="1">
        <Title className={classes.title}>{t('gfa.title')}</Title>
        <Subtitle className={classes.subTitle}>{t('gfa.subtitle')}</Subtitle>
        {!!warnText && <RiskAlert className={classes.riskAlert}>{t(warnText)}</RiskAlert>}
        <Tabs
          defaultKey={tabKey}
          onChange={(key) => {
            setTabKey(key);
          }}
        >
          {needValidations.map((v) => {
            const key = _.head(v);
            const validation = validations[key];

            return <Tabs.TabPane key={key} title={validation.title} />;
          })}
        </Tabs>
        <>
          {validations[tabKey].render({
            validationType: tabKey.toUpperCase(),
            onSuccess,
            verifyCanNotUseClick,
            isSub,
          })}
        </>
        {showLoginSafeWord ? (
          <SafeWordBox className={classes.safeWordBox}>
            <p className="safeword">{loginSafeWord || t('login.safe.word')}</p>
            <p className="safewordTips">
              {loginSafeWord ? t('has.login.safe.word.tips') : t('no.login.safe.word.tips')}
            </p>
          </SafeWordBox>
        ) : null}
      </Box>
    </Box>
  );
}
